{
	"accountMigration": "Account Migration",
	"accountTitle": "Account",
	"activities": "Activities",
	"activityTypeAccountCreation": "Account Creation",
	"activityTypeAdminAction": "Admin Action",
	"activityTypeCreditExpiration": "Credit Expiration",
	"activityTypeMembership": "Membership",
	"activityTypePayAsYouGoPurchase": "PAYG Purchase",
	"activityTypePromotionalBonus": "Promotional Bonus",
	"activityTypeReferralBonus": "Referral Bonus",
	"activityTypeUsage": "Usage",
	"activityTypeWelcomeBonus": "Welcome Bonus",
	"amount": "Amount",
	"appInfo": "App Info",
	"ariaAccount": "Account",
	"ariaContactSupport": "Contact Support",
	"ariaDeleteAccount": "Delete Account",
	"ariaDownloadReceipt": "Download Receipt",
	"ariaLogOut": "Log Out",
	"ariaManagePixiesetAccount": "Manage Pixieset Account",
	"ariaManageSubscription": "Manage Subscription",
	"ariaViewMoreAccountActivities": "View More Account Activities",
	"contactSupport": "Contact Support",
	"confirmDeleteTitle": "Confirm Account Deletion",
	"confirmDeleteMessage": "This action is final and cannot be undone. We strongly advise you to carefully consider this decision before proceeding.",
	"none": "None",
	"proPlan": "Pro",
	"subscriptionTierEssential": "Essential",
	"subscriptionTierFounders": "Founders",
	"subscriptionTierPremium": "Premium",
	"subscriptionTierStandard": "Standard",
	"subscriptionTierUltimate": "Ultimate",
	"subscriptionTierUnlimited": "Unlimited",
	"billingTermMonthly": "Monthly",
	"billingTermOneTime": "One-time",
	"billingTermYearly": "Yearly",
	"renewsOn": "renews {{date}}",
	"contactSupportTeam": "contact our support team",
	"date": "Date",
	"deleteAccountButton": "Delete Account",
	"deleteAccountSupport": "If you have any questions or concerns, please",
	"deleteAccountSupportSuffix": "for assistance.",
	"deleteAccountTitle": "Delete Account",
	"deleteAccountWarning": "Deleting your account will have significant and irreversible effects. All your data, preferences, history, and any previously purchased credits will be permanently erased and cannot be recovered.",
	"deleteFailedToast": "Failed to delete account. Please try again later.",
	"description": "Description",
	"downloadReceipt": "Download Receipt",
	"genAiCredits": "Gen-AI Credits",
	"genAiFreeUserCreditsTooltip": "Your current plan includes 100 trial Gen-AI credits. Upgrade your account for more.",
	"genAiSubscriberCreditsTooltip": "Your 250 Gen-AI credits reset at the start of each month. Unused credits do not roll over.",
	"infoBillingPlan": "Billing Plan",
	"infoExpires": "Expires",
	"infoExports": "Exports",
	"infoPayAsYouGoCredits": "Pay as you go credits",
	"infoReset": "Reset",
	"infoSubscription": "Subscription",
	"infoSubscriptionCredits": "Subscription credits",
	"infoSubscriptionTier": "Subscription Tier",
	"logOut": "Log Out",
	"manageAccount": "Manage Account",
	"manageSubscription": "Manage Subscription",
	"migrateLegacyAccount": "Migrate Legacy Account",
	"migrationCompletedOn": "Migration completed on",
	"migrationDescription": "Polarr Next users can migrate their styles and projects to this account.",
	"payAsYouGoDescription": "Pay as you go credits never expire and are only used after subscription credits are exhausted",
	"paygCredits": "PAYG Credits",
	"subscription": "Subscription",
	"subscriptionCredits": "Subscription Credits",
	"totalCredits": "Total Credits:",
	"type": "Type",
	"unlimited": "Unlimited",
	"upgrade": "Upgrade",
	"version": "Version:",
	"viewMoreActivities": "View More Activities"
}
